import httpClient from "../config/httpClient";

export abstract class DataConfigurationService {
	public static fetch<T>(key: string) {
		const url = `/sys03/data/configuration/${key}`;
		return httpClient.get<T>(url).then((response) => response.data);
	}

	public static fetchProvincePrefixes(province: string) {
		const url = `/sys03/data/configuration/PROVINCE_PREFIXES/${province}`;

		return httpClient.get<number[]>(url).then((response) => response.data);
	}

	public static patch<T>({ key, data }: { key: string; data: T }) {
		const url = `/admin/data/configuration/${key}`;
		return httpClient.patch(url, data);
	}

	public static put<T>({ key, data }: { key: string; data: T }) {
		const url = `/admin/data/configuration/${key}`;
		return httpClient.put(url, data);
	}
}
